/** Подписываемый init-config DocEditor от middleware (WUI-467). */
export type R7DocEditorInitConfig = {
  document: {
    fileType: string
    key: string
    title: string
    url: string
    permissions: Record<string, boolean>
  }
  documentType: 'word' | 'cell' | 'slide' | 'pdf'
  editorConfig: {
    mode: 'edit' | 'view'
    lang?: string
    customization?: { forcesave?: boolean }
    user: { id: string; name: string }
    callbackUrl?: string
  }
}

export function resolveR7DocEditorMode(config: R7DocEditorInitConfig | undefined): 'edit' | 'view' | undefined {
  const mode = config?.editorConfig?.mode
  return mode === 'view' ? 'view' : mode === 'edit' ? 'edit' : undefined
}

/** Минимальный init-config для тестов и моков prepare. */
export function createR7DocEditorInitConfigFixture(params: {
  documentKey: string
  documentUrl: string
  callbackUrl: string
  fileName?: string
  mode?: 'edit' | 'view'
  user?: { id: string; name: string }
}): R7DocEditorInitConfig {
  const mode = params.mode ?? 'edit'
  const canEdit = mode === 'edit'
  const fileName = params.fileName ?? 'document.docx'
  const fileType = fileName.includes('.') ? fileName.split('.').pop()!.toLowerCase() : 'docx'
  return {
    document: {
      fileType,
      key: params.documentKey,
      title: fileName,
      url: params.documentUrl,
      permissions: {
        edit: canEdit,
        download: true,
        print: true,
        review: canEdit,
        comment: canEdit,
        fillForms: canEdit,
        modifyFilter: canEdit,
        modifyContentControl: canEdit,
        copy: true,
      },
    },
    documentType: 'word',
    editorConfig: {
      mode,
      lang: 'ru',
      customization: { forcesave: canEdit },
      user: params.user ?? { id: '1', name: 'Test User' },
      callbackUrl: params.callbackUrl,
    },
  }
}
